export default "__VITE_ASSET__f06082fb__"